module.exports = __webpack_public_path__ + "images/emoji/ophiuchus.ccb9067a1b5add7e3a80.png";